import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import NoContentAdded, { NO_REVIEWER } from "NoContentAdded";
import Pagination from "react-js-pagination";
import {
  IMAGE_PATH,
  itemCount,
  COMMON_FAIL_MESSAGE,
  DATE_FORMAT_WITH_TIME,
} from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import LocaleStrings from "Languages";
import {
  openProposalSendTicketModal,
  sendTicket,
  openProposalResponseModal,
  fetchallproposal,
  updatedDragProposal,
} from "ProposalAction";

class ProposalSendTicket extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = { loading: false };
  }

  componentDidMount() {}

  closeModal() {
    this.props.openProposalSendTicketModal(false, "");
  }

  onSubmitForm = (values) => {
    var { showProposalTicketModal } = this.props;

    //console.log(values);
    values.id = showProposalTicketModal.response.id;
    this.setState({ loading: true });

    this.props.sendTicket(this.props.session, values, (response) => {
      //console.log('proposal',response);
      if (response.success === 0) {
        this.setState({ loading: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.props.fetchallproposal(this.props.session, (callback) => {
          this.props.updatedDragProposal(true);
          this.setState({ loading: false });
          this.props.showSuccess(
            LocaleStrings.proposal_response_send_ticket_successfully
          );
          this.props.reset();
          this.closeModal();
          this.props.openProposalResponseModal(false);
        });

        // this.props.handleSelect("shortlisted");
      }
    });
  };

  check = (str, val) => {
    return str.split(",").includes(val + "");
  };

  renderCustomSelect = (field) => {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;

    var fieldcss = "form-control dropdown-height-border";

    return (
      <div className={divClassName}>
        <label className="">
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>
        {/* <div className="col-sm-9 col-sm-offset-0"> */}
        <select className={fieldcss} {...field.input}>
          <option value="" key={field.label}>
            {field.placeholder}
          </option>
          {field.opts.map((object, index) => {
            return (
              <option key={index} value={object.value}>
                {object.name}
              </option>
            );
          })}
        </select>
        <div className="text-help label-text-help">
          {field.meta.touched ? field.meta.error : ""}
        </div>
        {/* </div> */}
      </div>
    );
  };

  render() {
    var {
      handleSubmit,
      pristine,
      reset,
      submitting,
      invalid,
      showProposalTicketModal,
      ticketSendList,
      userCategoryList,
    } = this.props;

    var tickets = [];
    var speakerDetails = _.filter(userCategoryList.data, (obj) => {
      return obj.type == "speaker";
    });
    var speakerid = speakerDetails.length > 0 ? speakerDetails[0].id : "";
    //console.log("speakerid", speakerid);
    if (ticketSendList && ticketSendList.resource) {
      var today = moment().format(DATE_FORMAT_WITH_TIME);

      ticketSendList.resource.forEach((item, index) => {
        var ticketDatetime = moment
          .utc(item.saleenddate)
          .local()
          .format(DATE_FORMAT_WITH_TIME);
        var validDate = moment(ticketDatetime).isAfter(today, "hours");

        if (
          item.usercategory &&
          //this.check(item.usercategory, speakerid) &&
          validDate
        ) {
          var obj = { name: `${item.ticketname}`, value: item.id.toString() };
          tickets.push(obj);
        }
      });
    }
    //console.log("tickets", tickets);

    return (
      <div>
        <Modal
          className="modal-container"
          enforceFocus={false}
          show={showProposalTicketModal.showModal === true ? true : false}
          animation={true}
        >
          <Modal.Header>
            <div className="import-modal-title">
              {LocaleStrings.proposal_send_ticket}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.closeModal()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <form onSubmit={handleSubmit(this.onSubmitForm)}>
            <Modal.Body>
              <Field
                name="ticketid"
                label="Choose Ticket"
                type="select"
                component={this.renderCustomSelect}
                mandatory="true"
                placeholder="Select Ticket"
                opts={tickets}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-custom-white"
                bsStyle=""
                onClick={this.closeModal}
              >
                {LocaleStrings.button_close}
              </Button>
              <Button
                className="btn btn-custom-blue ml-10"
                bsStyle=""
                loading={this.state.loading}
                disabled={pristine || invalid || submitting}
                type="submit"
              >
                {LocaleStrings.proposal_send_ticket_button}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showProposalTicketModal: state.showProposalTicketModal,
    ticketSendList: state.ticketSendList,
    userCategoryList: state.userCategoryList,
    eventDetails: state.userEventDetails,
  };
}

function validate(values) {
  // console.log('values',values);
  var errors = {};

  return errors;
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openProposalSendTicketModal,
  sendTicket,
  fetchallproposal,
  updatedDragProposal,
  openProposalResponseModal,
})(
  reduxForm({
    validate,
    form: "ProposalForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(ProposalSendTicket)
);
